import HeaderDate from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/HeaderDate'
import { DateTime } from 'luxon'
import HeaderBar from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/HeaderBar'
import SaleBookDetail from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail'
import { SummarySaleDetailProps } from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/interface'
import { ProductTypeSummary } from '@hooks/writer/useWriterAction'
import { SHOW_EBOOK_FEATURE } from '@configs/config'

const SummarySaleDetail = ({ dateSelected }: SummarySaleDetailProps) => {
  return (
    <>
      <HeaderBar className='mt-[40px]' title='รายละเอียดการขาย' />
      <div className='w-full shadow-card bg-white dark:bg-dark-8 rounded-[8px] border border-gray-4 dark:border-purple p-[30px] mt-[40px]'>
        <HeaderDate month={DateTime.fromJSDate(dateSelected.endDate)} />
        <div className='w-full border-b-[1px] border-[#eeeeee] dark:border-purple mt-[30px]' />
        <SaleBookDetail
          type={ProductTypeSummary.NOVEL_CHAPTER}
          dateSelected={dateSelected}
        />
        <SaleBookDetail
          type={ProductTypeSummary.MANGA_CHAPTER}
          dateSelected={dateSelected}
        />
        {SHOW_EBOOK_FEATURE && (
          <>
            <SaleBookDetail
              type={ProductTypeSummary.NOVEL_EBOOK}
              dateSelected={dateSelected}
            />
            <SaleBookDetail
              type={ProductTypeSummary.MANGA_EBOOK}
              dateSelected={dateSelected}
            />
          </>
        )}
        <SaleBookDetail
          type={ProductTypeSummary.DONATION}
          dateSelected={dateSelected}
        />
      </div>
    </>
  )
}

export default SummarySaleDetail
